import API from "../utils/api";

const createSale = async (data) => {
  const res = await API.post(`/api/sales`, data);
  return res.data;
};
const getSales = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await API.get(`/api/sales${query ? `?${query}` : ""}`);
  console.log("getSales response:", res.data);
  return res.data;
};
const getSingleSale = async (id) => {
  const res = await API.get(`/api/sales/${id}`);
  return res.data;
};

const updateSale = async (id, data) => {
  const res = await API.put(`/api/sales/${id}`, data);
  return res.data;
};


const addPayment = async (saleId, data) => {
  const res = await API.post(`/api/sales/${saleId}/payments`, data);
  return res.data;
};
const getSalePayments = async (saleId) => {
  const res = await API.get(`/api/sales/${saleId}/payments`);
  return res.data;
};

const voidSale = async (id, data) => {
  const res = await API.patch(`/api/sales/${id}/void`, data);
  return res.data;
};

const getCumulativeSales = async () => {
  const res = await API.get(`/api/sales/cumulative`);
  console.log("getCumulativeSales response:", res.data);
  return res.data;
};


const saleService = {
  createSale, getSales, getSingleSale,
  updateSale, voidSale,               // ✅ void replaces delete
  addPayment, getSalePayments, getCumulativeSales
};
export default saleService;